import { render, staticRenderFns } from "./LinkUiComponent.vue?vue&type=template&id=30e0d159&"
import script from "./LinkUiComponent.vue?vue&type=script&lang=ts&"
export * from "./LinkUiComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports